
import { rxRoute } from "../../../../helpers/formatting";

const usePath = (path, serverData) => {
    const enabledVirtualDashboard = serverData && serverData.enableVirtualDashboardUpdates ? serverData.enableVirtualDashboardUpdates : false;
    const enableCustomDirectScheduling = serverData && serverData.enableCustomDirectScheduling;
    switch (path.toLowerCase()) {
        //apply for all the routes which are not mapped to navitem.
        case "/proxyrequestdob":
        case "/proxyrequest":
        case "/grantaccessproxy":
        case "/acceptproxy":
            return "/proxyManagement";
        case "/schedule":
            return enableCustomDirectScheduling ? "/schedule/DirectSchedule" : "";
        case "/evisitnow":
        case "/evisittravel":
            return "/evisit";
        case "/aatravel":
            return "/videovisitscheduledfor";
        case "/admininfo":
            return "/demographics";
        case "/coverage":
            return "/insurance";
        case "/nonbswtransfer":
        case "/bswtransfer":
        case "/pharmacynonbswtransfer":
        case "/pharmacybswtransfer":
            return rxRoute('rxTransfer');
        case "findcarefrominperson": //this is not actual route
            return "/inperson";
        case "/schedulevideovisit":
            return enabledVirtualDashboard ? "/videovisitscheduledfor" : "/videoondemand";
        case "/preferencesettings":
            return "/notifications";
        case "/carecoachmessage":
            return "/carecompanion";
        case "/wellbeingmessage":
            return "/wellbeinginbox";
        case "/inhomeschedule":
            return "/inhomevaccine";
        default:
            return path;
    }
}

export default usePath;
